import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { Page } from './types'

type InitialState = {
  page: Page
  props?: { groupId: string; id: string }
  previousPage: Page
}

const pageFromLocalStorage: InitialState = JSON.parse(
  localStorage.getItem('page') as string
) || { page: 'Home', previousPage: 'Home' }

const initialState: InitialState = pageFromLocalStorage

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setCurrentPage: (
      state,
      { payload }: PayloadAction<{ page: Page; props?: InitialState['props'] }>
    ) => {
      state.previousPage = state.page
      state.page = payload.page
      state.props = payload.props
      localStorage.setItem('page', JSON.stringify(state))
    },
  },
})

export const { setCurrentPage } = pageSlice.actions

export const selectCurrentPage = (state: RootState) => state.page.page
export const selectPageProps = (state: RootState) => state.page.props
export const selectPreviousPage = (state: RootState) => state.page.previousPage

export default pageSlice
